const ROUTES = {
    OUR_TEAM: "/our-team",
    CONTACT_US: "/contact-us"
}

export default ROUTES
